import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";
import { ISavedPageAddRequest } from "../../models/SavedPage/ISavedPageAddRequest";
import { IUserProfile } from "../../@types/Wyanoke/UserProfile"
import { UiUtil } from "../../util/UiUtil";
import { WyanokeUtil } from "../../util/WyanokeUtil";

export class MySavedPages extends Component {
  constructor(element: HTMLElement, pageContext: PageContext) {
    super(element, pageContext);
  }

  public async init(): Promise<void> {
    // console.log(`MySavedPages Initializing: ${this._element.className}`);
    const profile = await WyanokeUtil.loadUserProfile(true, false);
    if (!profile) {
      console.error("Profile is not loaded");

      return;
    }

    const siteName = this._element.getAttribute("data-site") || "";
    if(siteName.length < 1) {
      console.error("data-site attribute is required.");

      return;
    }

    const editBtn = this._element.querySelector("[data-button=edit]");
    if (!editBtn) {
      console.error("Edit Button not found");

      return;
    }

    const slidingElement = this._element.querySelector("[data-slide-offset]");
    if (!slidingElement) {
      console.error("Sliding Element not found");

      return;
    }

    const offset = Number(
      slidingElement.getAttribute("data-slide-offset")
    ).valueOf();
    const duration = 500;

    editBtn.addEventListener("click", () => {
      editBtn.innerHTML = editBtn.innerHTML === "Edit" ? "Done" : "Edit";
      UiUtil.animateSlide(slidingElement, offset, duration, () => {
        $(".card--layout").masonry("layout");
      });
    });

    $(".card--layout").on("layoutComplete", (evt, items) => {
      slidingElement
        .querySelectorAll("[data-button=remove]")
        .forEach(async deleteBtn => {
          const databound = deleteBtn.getAttribute("data-bound") || "";
          if(databound.length > 0) {
            return false;
          }

          const itemId = deleteBtn.getAttribute("data-item-id") || "";
          console.log(`Binding 'Remove Button' for ${itemId}`);
          if (itemId === "") {
            console.error("data-item-id missing or empty");

            return false;
          }
          const context = this._pageContext;
          const service = context ? context.savedPageService : null;
          if (!service) {
            return false;
          }

          deleteBtn.setAttribute("data-bound", "1");

          deleteBtn.addEventListener("click", async () => {
            console.log(`Removing${itemId}`);
            const savedItem = await this.savedPage(profile, itemId, siteName);
            if (savedItem !== null && service) {
              // tslint:disable-next-line: no-unsafe-any
              await service.remove(savedItem);
              console.log(`${savedItem.documentid} Removed`);
              const listItem = deleteBtn.closest("[data-list-item]");
              if (listItem) {
                $(".card--layout")
                  .masonry("remove", listItem)
                  .masonry("layout");
                // listItem.remove();
              }
            }
          });
        });
    });
  }

  private async savedPage(
    profile: IUserProfile,
    activityId: string,
    siteName: string
  ): Promise<ISavedPageAddRequest | null> {
    if (!profile) {
      return null;
    }

    const userId = profile.contactid || null;
    if (!userId || !activityId) {
      return null;
    }

    return {
      contenttype: ["news"],
      documentid: activityId,
      expires: "",
      site: siteName,
      title: "",
      url: "",
      userid: userId,
    };
  }
}

ComponentFactory.registerComponent("MySavedPages", MySavedPages);
ComponentFactory.registerComponent("MySavedPagesMobile", MySavedPages);
